/* eslint-disable quote-props */
/* eslint-disable react/react-in-jsx-scope */
import { SxProps, Tabs } from "@mui/material";

interface ITabsCustomProps {
  ariaLabel: string;
  value: string;
  onChange: (event: React.SyntheticEvent, value: string) => void;
  sx?: SxProps;
  children: React.ReactNode;
}

const TabsCustom = ({ ariaLabel, value, onChange, sx, children }: ITabsCustomProps) => {
  return (
    <Tabs
      aria-label={ariaLabel}
      value={value}
      onChange={onChange}
      sx={{
        width: { xs: "100%", md: "fit-content" },
        paddingTop: "40px",
        "& .MuiTabs-indicator": {
          backgroundColor: "primary.main",
          height: "3px",
        },
        "& .MuiTabs-flexContainer": {
          borderBottom: "1px solid",
          borderColor: "taupe.dark",
        },
        ...sx,
      }}
    >
      {children}
    </Tabs>
  );
};

export default TabsCustom;
